import React, {useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {get, post} from "../../../../../Model/Network/Config/Axios";
import {handleError, showToast} from "../../../../Common/fToast/ToastCallback";
import {Title as Header} from "../../../../Header/TopHeader";
import Items from './AllItems'
import Terms from './Terms'
import Payment from './Payment'
import Grn from './Grn';
import OfficeModal from '../../../../Common/fModal/OfficeModal';
import Invoices from './Invoices';
import VendorTerms from './VendorTerms';
import View from './View';
import Advance from './Advance';
import { Modal } from '../../../../Common/fModal/Modal';
import { DatePickerCustom, FunctionalInput } from '../../../../Common/fInputs';
import { EmployeeSearchable } from '../../../../Common/Class/Select/EmployeeSearchable';
import AllGrn from './GRN/AllGrn'
import { VendorAddressSearch } from '../../../../Common/fVendor/VendorAddressSearch';
import { EditableCustomForm } from '../../../../Common/EditableCustomForm';
import ProvisionDetails from './ProvisionCondition/index';
import Asn from './asn';
import { ProductSearch } from '../fRfqDetails/ProductSearch';
import useDateFormat from '../../../fCommon/useDateFormat';
import { SearchOffice2 } from '../../../../Common/fSubmitInvoice/common/SearchOffice';
import moment from 'moment';
import { ReadOnly } from '../../../../Common/fCard/ButtonOutline/ReadOnly';
import GrnConditions from './GRN/GrnConditions';
import { CustomTagsContract } from '../../../fCommon/CustomTags/CustomTags';
import Title from '../../../../Common/Title';
import SelectGST from '../../../../Common/fUtils/SelectGST';
import { StateButton } from '../../../../Common/fStateButton';
import { PoCostAllocation } from './PoCostAllocation';
import { AllocationView } from './AllocationView';
import GIN from './GIN';


const Details = (props) => {


	const [short,setShort] = useState(false);
	const [name,setName] = useState(false);
	const [addressType, setAddressType] = useState(false);
	const [employee,setEmployee] = useState(false);
	const [vendorAddress,setVendorAddress] = useState(false);
	const [addLineItem,setAddLineItem] = useState(undefined);
	const [product,setProduct] = useState(undefined);
	const [productGST,setProductGST] = useState(undefined);
    const [shipping,setShipping] = useState(undefined);
	const [completePo,setCompletePo] = useState(false);
	let tenant = useSelector(state=>state.auth.config.tenant);
	let {optionalFields,disableShortClosure,enableGin,poCostAllocation,prCostAllocation,mandatoryPoCostAllocation,costAllocationAtLineItem}= useSelector(state=>state.auth.config.plugins);
	const [show,setShow]=useState(false);
	const [items,setItems] = useState([]);
	const [loading,setLoading] = useState(true);
	const [btnLoading,setBtnLoading] = useState(false);
	const [addCostAllocation,setAddCostAllocation] = useState(false);
	const [updateCostAllocation,setUpdateCostAllocation] = useState(false);
	const [removeCostAllocation,setRemoveCostAllocation] = useState(false);
	const [allocation,setAllocation] = useState(undefined);

	let REMARKS = useRef(),QTTY=useRef(),BASE=useRef(),DELIVERY_DATE=useRef(),NOTES=useRef();
	const COSTALLOCATION = useRef();
	const ALLOCATION = useRef();

	let dateFormate = useDateFormat('MM-DD-YYYY')
	const {grn} = useSelector(config=>{
		return{grn:config.auth.config.plugins.grn}
	})

	let fetchASN=()=>{
		setLoading(true);
		let data ={
			startDate:1672511400000,
			endDate:moment().add(30,'days').valueOf(),
			po_id:props.id
		};
	
		// data.filter=`${props.id}@po_id`;
	
		get(`vendor/procurement/asn/getAll`,(e,r)=>{
			if(r) {
				setItems(r.asnList);
				setLoading(false);
			}
		},data)
	}

	useEffect(() => {
		if (product) setProductGST({ label: product.gst, value: product.gst });
	}, [product])


	useEffect(() => {
		let getAllocations = () => {
			get(`vendor/costAllocation/getAllocations?referenceType=${'purchase-order'}&referenceId=${id}`,(e,r)=>{
				if(r) {
					setAllocation(r);
					setAddCostAllocation(true)
				}
			})
		}
		if(updateCostAllocation) {
			getAllocations()
		}
	}, [updateCostAllocation])

	let scrollInto = (terms) => {
		let section = document.getElementById(terms);
		if (section) {
			section.classList.add('blinkIt');
			setTimeout(() => {
				section = document.getElementById(terms);
				if (section) {
					section.classList.remove('blinkIt');
				}
			}, 2000);
			section.scrollIntoView({behavior: 'smooth', block: 'start'});
		}
	}

	let button = () => {
		let {data, id, init} = props;
		let {status} = data;
		return (
			<div style={{
				display: 'flex',
				alignItems: 'center',
				position: 'absolute',
				right: 12,
				top: 25,
				justifyContent: 'center'
			}}>

				{
					status === "DRAFT" ?
				 <ReadOnly>
							{btnLoading ?
								<divc className="btn btn-portlet-sucess" style={{ width: 200}}>
									<StateButton />
								</divc>
								:
								<div style={{
									fontSize: 11,
									marginLeft: 20,
									width: 200,
								}}
									className="btn btn-portlet"
									onClick={() => {
										if(mandatoryPoCostAllocation && !costAllocationAtLineItem && data && !data.costAllocationDone){
											showToast({
												type:'error',
												message:"Cost Allocation is mandatory"
											})
											return;
										}
									if (costAllocationAtLineItem && mandatoryPoCostAllocation) {
										const hasMissingCostAllocation = props.data.procured.some(item => {
											return !item.costAllocations || (item.costAllocations && item.costAllocations.length === 0);
										});
										if (hasMissingCostAllocation) {
											showToast({
												type: 'error',
												message: "Cost Allocation is mandatory for all line items"
											})
											return;
										}
									}

										if(tenant === 'BSETEST') {
											if(conditions.length > 0) {
												setBtnLoading(true)
												post(`vendor/po/requests/${id}/draft`, {}, (e, r) => {
													if (r) {
														init()
														setBtnLoading(false)
													} else {
														handleError(e)
														setBtnLoading(false)
													}
												})

											} else {
												showToast({
													type:'error',
													message:"Please add the conditions first"
												})
												return;
											}
										} else {
											setBtnLoading(true)
											post(`vendor/po/requests/${id}/draft`, {}, (e, r) => {
												if (r) {
													init()
													setBtnLoading(false)
												} else {
													handleError(e)
													setBtnLoading(false)
												}
											})
										}

									}}>
									Move Next
								</div>
							}
					</ReadOnly> : undefined
				}
				{
					status === "ADMINTOUCH" ?
						<ReadOnly>
							{btnLoading ?
								<div className="btn btn-portlet-sucess" style={{ width: 200}}>
								 <StateButton />
								</div>
								:
								<div style={{
									fontSize: 11,
									marginLeft: 20,
									width: 200,
								}}
									className="btn btn-portlet"
									onClick={() => {
										setBtnLoading(true)
										post(`vendor/po/requests/${id}/touch`, {}, (e, r) => {
											if (r) {
												init()
												setBtnLoading(false)
											} else {
												handleError(e)
												setBtnLoading(false)
											}
										})
									}}>
									Move Next
								</div>
							}
						</ReadOnly>
						: undefined
				}
				{
					status === "HOLD" && false ? 
					 <ReadOnly>
						{btnLoading ?
							<div className="btn btn-portlet-sucess" style={{ width: 200 }}>
								<StateButton />
							</div>
							:
							<div style={{
								fontSize: 11,
								marginLeft: 20,
								width: 200,
							}} className="btn btn-portlet" onClick={() => {
								setBtnLoading(true)
								post(`vendor/po/requests/${id}/moveGrn`, {}, (e, r) => {
									if (r) {
										init()
										setBtnLoading(false)
									} else {
										handleError(e)
										setBtnLoading(false)
									}
								})
							}}>
								DO GRN
							</div>
						}
					</ReadOnly>
						: undefined
				}
				{
					status === "SCHEDULE" ?
						<ReadOnly>
							{btnLoading ?
								<div className="btn btn-portlet-sucess" style={{ width: 200 }}>
									<StateButton />
								</div>
								:
								<div style={{
									fontSize: 11
								}} className="btn btn-portlet" onClick={() => {
									setBtnLoading(true)
									post(`vendor/po/schedule/${id}/move`, {}, (e, r) => {
										if (r) {
											init()
											setBtnLoading(false)
										} else {
											handleError(e)
											setBtnLoading(false)
										}
									})
								}}>
									Post Po
								</div>
							}
						</ReadOnly> : undefined
				}
				{!disableShortClosure && tenant && tenant !== 'DTDC2' ?
					status === 'APPROVAL' || status === 'INVOICE' ?
						<ReadOnly>
							{btnLoading ?
								<div className="btn btn-portlet-sucess" style={{ width: 200 }}>
									<StateButton />
								</div>
								:
								<div style={{
									fontSize: 11,
									marginLeft: 20,
									width: 200,
								}} className="btn btn-portlet" onClick={() => {
									setCompletePo(true);
								}}>
									Complete
								</div>
							}
						</ReadOnly> : undefined
					: null}

			</div>
		)
	}


	let {data, id,init} = props;
	let { vendor, status, invoices,conditions} = data;
	
	const savePoItem = () =>{
		let qtty = QTTY.current.value;
		let base = BASE.current.value;
		let notes = NOTES.current.value;
		let date = DELIVERY_DATE.current.value;

		if(!product) {
			showToast({
				type:'error',
				message:'Please select the product first'
			})
			return;
		}

		if(!shipping) {
			showToast({
				type:'error',
				message:'Please select the Delivery address'
			})
			return;
		}

		if(!date) {
			showToast({
				type:'error',
				message:'Please select the Delivery date'
			})
			return;
		}

		if(!qtty) {
			showToast({
				type:'error',
				message:"Enter the quantity"
			})
			return;
		}
		if(!base) {
			showToast({
				type:'error',
				message:"Please enter the base amount"
			})
			return
		}
		if(!notes && !optionalFields) {
			showToast({
				type:'error',
				message:"Please enter the notes"
			})
			return;
		}
	
		let data = {
		  qtty: Number(parseFloat(qtty).toFixed(3)),
		  product:{
			value:product.value
		  },
		  base: +base,
		  notes,
		  shipTo:shipping ? {value:shipping.value }: null,
		  tax:productGST.value
		}
		if(date) {
			data.date = date.valueOf()
		}
		
		post(`vendor/po/requests/${id}/addPoItem`,{item:data},(e,r)=>{
			if(r) {
				showToast({
					type:'success',
					message:"Item added successfully"
				});
				props.init();
				setAddLineItem(false);
				setProduct(undefined)
				setProductGST(undefined);
				setShipping(undefined)
			} else {
				showToast({
					type:'error',
					message:e.data.message
				})
			}
		})
	}

	const onAddCostAllocation = () => {
		if (btnLoading) {
			return;
		}

		let costAllocation = COSTALLOCATION.current.getValue();

		if (costAllocation === true) {
			showToast({
				type: 'error',
				message: "Please update the cost allocation"
			})
			return;
		}

		if(costAllocation === false) return

		// let costAllocationAtItems = {};
		// invoices.forEach(i => {
		// 	if (i.costAllocations) {
		// 		costAllocationAtItems[i.id] = i.costAllocations
		// 	}
		// })
		setBtnLoading(true);
      if(updateCostAllocation){
		  post(`/vendor/po/requests/${id}/po.costAllocation.update`,{costAllocation}, (e, r) => {
			  if (r) {
				  setAddCostAllocation(false);
				  setBtnLoading(false);
				  setUpdateCostAllocation(false);
				  props.init();
				  if (ALLOCATION.current && ALLOCATION.current.INIT) {
					  ALLOCATION.current.INIT();
				  }
				  showToast({
					type: 'success',
					message: "Cost allocation updated successfully"
			    	})
				  // Reload the Allocation component
			  } else {
				  setBtnLoading(false)
				  handleError(e)
			  }
		  })
	  }else {
		post(`/vendor/costAllocation/addPoLocation`, {poId:Number(id),request:{...costAllocation}}, (e, r) => {
			if (r) {
				setAddCostAllocation(false);
				setBtnLoading(false);
				setUpdateCostAllocation(false);
				props.init();
				// Reload the Allocation component
				if (ALLOCATION.current && ALLOCATION.current.INIT) {
					ALLOCATION.current.INIT();
				}
				showToast({
					type: 'success',
					message: "Cost allocation added successfully"
				})
			} else {
				setBtnLoading(false)
				handleError(e)
			}
		})
	}
	}

	
	return (
		<div>
			<div className="input-container" style={{padding: 0, marginTop: 30, marginBottom: 0}}>
				<div style={{
					display: 'flex',
					padding: 25,
					position: 'relative',
				}}>
					{
						data.logo ?
							<div style={{
								flex: 0.2,
								marginBottom: 15
							}}>
								<img src={data.logo} alt="" style={{
									height: 40,
									objectFit: 'contain'
								}}
								/>
							</div> : null
					}
					<div>
						<p style={{
							fontSize: 21,
							color: "var(--text-color)",
							fontWeight: 700
						}}>
							{data.orderId}
						</p>
						<p style={{
							fontSize: 11,
							color: 'var(--light-color)'
						}}>
							Details of selected po appears below.
						</p>
					</div>
					{
						button()
					}
				</div>
				<div style={{borderTop:'1px solid var(--border-color)',padding:20,paddingTop:10,paddingBottom:10}}>
					<p style={{fontWeight:600,fontSize:16}}>{data.title?data.title:'-'}</p>
					<div style={{
						display:'flex',
						alignItems:'center'
					}}>
						<p className='capsule'>CATEGORY : {data.category.name}</p>
						{
							data.poType?
							<p className='capsule'>PO Type : {data.poType.title || "-"}</p>
							:null
						}
						{
							data.endDate ?
							<p className='capsule'>End Date : {moment(data.endDate).format('DD-MM-YYYY')}</p>
							: null
						}
					</div>
				</div>
				<div style={{
					borderTop: '1px solid var(--border-color)',
					display: 'flex',
					flexDirection: 'row'
				}}>
					<div style={{
						width: 180,
						borderRight: '1px solid var(--border-color)',
						padding: 20
					}}>
						<p style={{
							fontSize: 9,
							color: "var(--light-color)",
							fontWeight: 600,
							letterSpacing: 1,
							marginBottom: 12,
							textTransform: 'uppercase'
						}}>
							Go to
						</p>
						<p onClick={() => {
							scrollInto("items")
						}} style={{
							fontSize: 12,
							color: "var(--primary-color)",
							marginTop: 5,
							fontWeight: 600,
							cursor: 'pointer'
						}}>
							Items
						</p>
						<p onClick={() => {
							scrollInto("attachments")
						}} style={{
							fontSize: 12,
							color: "var(--primary-color)",
							marginTop: 5,
							fontWeight: 600,
							cursor: 'pointer'
						}}>
							Attachments
						</p>
						<p onClick={() => {
							scrollInto("comments")
						}} style={{
							fontSize: 12,
							color: "var(--primary-color)",
							marginTop: 5,
							fontWeight: 600,
							cursor: 'pointer'
						}}>
							Comments
						</p>
						<p onClick={() => {
							scrollInto("timeline")
						}} style={{
							fontSize: 12,
							color: "var(--primary-color)",
							marginTop: 5,
							fontWeight: 600,
							cursor: 'pointer'
						}}>
							Timeline
						</p>
						<p onClick={() => {
							scrollInto("terms")
						}} style={{
							fontSize: 12,
							color: "var(--primary-color)",
							marginTop: 5,
							fontWeight: 600,
							cursor: 'pointer'
						}}>
							Terms & Condition
						</p>
					</div>
					<div className="flex-1" style={{
						padding: 18,
						display: 'flex'
					}}>
						<div style={{
							padding: 12,
							flex:1,
							border: '1px solid var(--border-color)'
						}}>
							<p style={{
								fontSize: 9,
								color: 'var(--light-color)',
							}}>
								Supplier Details {(invoices.length===0 || status==='DRAFT') ? <ReadOnly>
									<span style={{
									fontWeight: 700,
									paddingLeft: 10,
									textTransform: 'uppercase',
									cursor: 'pointer',
									color: "var(--light-color)"
								}} onClick={() => {
									setVendorAddress(vendor.id);
								}}>Edit</span>
								</ReadOnly> : null}
							</p>
							<p style={{
								marginTop: 10,
								color: "var(--text-color)",
								fontSize: 15,
								fontWeight: 600
							}}>
								{
									vendor.name
								}
							</p>
							<p style={{
								fontSize: 11,
								color: "var(--light-color)"
							}}>
								{vendor.email}
							</p>
							<p style={{
								fontSize: 11,
								color: "var(--light-color)"
							}}>
								{vendor.mobile}
							</p>
							<p style={{
								fontSize: 11,
								color: "var(--light-color)"
							}}>
								Gstin: {vendor.gstin ? vendor.gstin : '-'}
							</p>
							<p style={{
								fontSize: 11,
								color: "var(--light-color)"
							}}>
								Address: {(vendor.address && vendor.address.address) ? vendor.address.address : '-'}
							</p>
						</div>

						<div style={{
							padding: 12,
							marginLeft:12,
							flex:1,
							border: '1px solid var(--border-color)'
						}}>
							<p style={{
								fontSize: 9,
								color: 'var(--light-color)',
							}}>
								Billing Details {(invoices.length===0 || status==='DRAFT' || (status==="PENDING" && data && data.integrationData && data.integrationData.postingFailed))  ? <ReadOnly>
								{!(data && data.integration && data.integration.postingSynced && (["STELMC","STELMEC"].includes(tenant))) ? <span style={{
									fontWeight: 700,
									paddingLeft: 10,
									textTransform: 'uppercase',
									cursor: 'pointer',
									color: "var(--light-color)"
								}} onClick={() => {
									setAddressType('billTo');
								}}>Edit</span>:null}
								</ReadOnly> : null}
							</p>
							<p style={{
								color: "var(--text-color)",
								fontSize: 15,
								marginTop: 12,
								fontWeight: 600
							}}>
								{
									data.billingTo.name
								}
							</p>
							<p style={{
								color: "var(--light-color)",
								fontSize: 11,
							}}>
								{
									data.billingTo.address
								}
							</p>
							<p style={{
								fontSize: 11,
								color: "var(--light-color)"
							}}>
								{
									data.billingTo.city
								}
							</p>
							<p style={{
								fontSize: 11,
								color: "var(--light-color)"
							}}>
								{
									data.billingTo.country
								}
							</p>
							<p style={{
								fontSize: 11,
								color: "var(--light-color)"
							}}>
								{
									data.billingTo.gstin?data.billingTo.gstin:"-"
								}
							</p>
						</div>
						<div style={{
							padding: 12,
							marginLeft:12,
							flex:1,
							border: '1px solid var(--border-color)'
						}}>
							<p style={{
								fontSize: 9,
								color: 'var(--light-color)',
							}}>
								Invoice Owner Details
							</p>
							<p style={{
								color: "var(--text-color)",
								fontSize: 15,
								fontWeight: 600
							}}>
								<Link to={`/app/organisation/employee/${data.details.raisedBy.ownerId}`} target="_blank">
									<span style={{fontSize: '12px'}}>
										{data.details.raisedBy.ownerName}
									</span>
								</Link> {status !== 'COMPLETED' ?
								<ReadOnly><span style={{
								fontWeight: 700,
								paddingLeft: 10,
								textTransform: 'uppercase',
								cursor: 'pointer',
								color: "var(--light-color)",
								fontSize:9
							}} onClick={() => {
								setName("admin")
							}}>Edit</span></ReadOnly> : null }
							</p>
							<p style={{
								fontSize: 9,
								color: 'var(--light-color)',
								marginTop: '15px'
							}}>
								Grn Owner  {status !== 'COMPLETED' ?
								<ReadOnly>
									<span style={{
									fontWeight: 700,
									paddingLeft: 10,
									textTransform: 'uppercase',
									cursor: 'pointer',
									color: "var(--light-color)"
								}} onClick={() => {
									setName("grn")
								}}>Edit</span>
								</ReadOnly> : null }
							</p>
							<p style={{
								color: "var(--text-color)",
								fontSize: 15,
								fontWeight: 600
							}}>
								{data.grnOwner ?
								<Link to={`/app/organisation/employee/${data.grnOwner.ownerId}`} target="_blank">
									<span style={{fontSize: '12px'}}>
										{data.grnOwner.ownerName}
									</span>
								</Link>
								: 'Not-defined'
								}
							</p>
							{enableGin &&
								<div>
									<p style={{
										fontSize: 9,
										color: 'var(--light-color)',
										marginTop: '15px'
									}}>
										GIN Owner  {status !== 'COMPLETED' ?
											<ReadOnly>
												<span style={{
													fontWeight: 700,
													paddingLeft: 10,
													textTransform: 'uppercase',
													cursor: 'pointer',
													color: "var(--light-color)"
												}} onClick={() => {
													setName("gin")
												}}>Edit</span>
											</ReadOnly> : null}
									</p>
									<p style={{
										color: "var(--text-color)",
										fontSize: 15,
										fontWeight: 600
									}}>
										{data.ginOwner ?
											<Link to={`/app/organisation/employee/${data.ginOwner.ownerId}`} target="_blank">
												<span style={{ fontSize: '12px' }}>
													{data.ginOwner.ownerName}
												</span>
											</Link>
											: 'Not-defined'
										}
									</p>
								</div>
							}
						</div>
					</div>
				</div>
			</div>
			<div style={{
				padding: '0px 25px'
			}}>
				<Header container={true} id="items" title="Order Items" des="All order items are visible here">
					<div style={{
						position:'absolute',
						right:0
					}}>
						{(status === 'DRAFT' && !(data && data.integration && data.integration.postingSynced && (["STELMC","STELMEC"].includes(tenant)))) ? (
							<ReadOnly>
								<div style={{
									fontSize: 13,
									cursor: 'pointer',
									fontWeight: 700,
									width: 125,
									color: "var(--primary-color)",
									textTransform: 'uppercase'
								}} onClick={() => {
									setAddLineItem(true)
								}}>
									+ Add Product
								</div>
							</ReadOnly>
						) : ((tenant && tenant === 'DTDC2') && status === 'PENDING') && (
							<ReadOnly>
							<div style={{
								fontSize: 13,
								cursor: 'pointer',
								fontWeight: 700,
								width: 125,
								color: "var(--primary-color)",
								textTransform: 'uppercase'
							}} onClick={() => {
								setAddLineItem(true)
							}}>
								+ Add Product
							</div>
							</ReadOnly>
						)}
					 { status === 'GRN' && !disableShortClosure	&& <ReadOnly>
						<button style={{
								border:'var(--primary-color)',
								background:'var(--primary-color)',
								padding:'8px 20px',
								color:"var(--white-color)",
								borderRadius:4,
								cursor:'pointer'
							}} onClick={() => {
									setShort(true);
								}}>
								Short Closure
						</button>
					 </ReadOnly>
					}
					</div>
				</Header>
			</div>

			<div className="input-container" style={{padding: 25, marginBottom: 0}}>
				{
					<Items status={status} {...props} currency={props.data.currency} costAllocationAtLineItem={costAllocationAtLineItem}/>
				}
			</div>
				{/* PO cost allocation */}
			{
				(poCostAllocation || prCostAllocation) ?
					<div className="input-container" style={{ padding: 25, marginBottom: 20, marginTop: 20 }}>
						<p style={{ fontSize: 14, fontWeight: 600, marginBottom: 10, marginTop: 10 }}>Cost Allocation</p>
						<AllocationView
							ref={ALLOCATION}
							type="purchase-order"
							reference={Number(id)}
							poData={data}
							onAdd={() => { setAddCostAllocation(true) }}
							onUpdate={() => { setUpdateCostAllocation(true) }}
							onRemove={() => { setRemoveCostAllocation(true) }}
						/>
					</div>
					: null
			}
			{
					addCostAllocation ?
						<div className="input-container" style={{ padding: 25, marginBottom: 20,marginTop:20 }}>
							<PoCostAllocation
								ref={COSTALLOCATION}
								loading={btnLoading}
								allocation={allocation}
								updateCostAllocation={updateCostAllocation}
								onClose={() => { setUpdateCostAllocation(false);setAddCostAllocation(false) }}
								onAdd={onAddCostAllocation}
								data={data}
							/>
						</div>
						: null
			}
			{
				grn && (status === "GRN" || status === "APPROVAL" || status === "INVOICE" || status === "COMPLETED" )?
							<Grn {...props} />
					: null
			}
			<AllGrn data={data} {...props} />
			<GrnConditions data={data} {...props} id={id} />

			<div style={{ marginBottom: 0 }}>
				<Invoices
					fetchASN={fetchASN}
					status={status}
					data={data}
					reload={() => {
						props.init();
					}}
				/>
			</div>

			{
				props.data.forms && props.data.forms.length ?
				<>
				<Header container={true} id="form" title="Form" />
				<div className='input-container' style={{marginTop:20}}>
					<EditableCustomForm type="po" id={props.data.category.id} onChange={(key,value)=>{
						let data = {
							key,
							value
						}
						if(status==='GRN' || status==='PENDING' || status==='DRAFT' || status==='ADMINTOUCH') {
							data.force = true
						}
						post(`vendor/po/requests/${id}/updateDetails`,data,(e,r)=>{
							if(r) {
								showToast({
									type:'success',
									message:"Form updated successfully"
								});
								props.init();
							} else {
								showToast({
									type:'error',
									message:e.data.message
								})
							}
						})
					}} data={props.data.forms}  />
				</div>
				</>
				:null
			}


			<div>

				
				<div style={{marginBottom: 0}}>
				<GIN status={status} data={data}/>
			</div>
				<Asn items={items} loading={loading} fetchASN={fetchASN} {...props}/>
				</div>
				<Advance {...props} init={()=>{
					init()
				}} />
				<View data={data}/>
				<VendorTerms {...props} />
				<Terms {...props}/>
				{tenant !== "STELMC" && 
					<Payment {...props}/>
				}
				<ProvisionDetails {...props} />
				<div style={{padding:'0px 40px'}}>
					<Title title="Custom Tags" />
				</div>
				<div className="input-container">
					<div style={{border:'1px solid var(--border-color)',padding:12,borderRadius:12,marginTop:20,paddingTop:10}}>
						<div style={{'display':'flex','justifyContent':'space-between'}}>
							<div onClick={() => {setShow((!show))}} style={{fontSize: '14px', fontWeight: 'bold', cursor:'pointer'}}>Custom Tags</div>
							<div style={{'border':'1px solid black', 'borderRadius':'100%', width:'18px',height:'18px','display':'flex','justifyContent':'center', 'alignItems':'center',cursor:'pointer'}} onClick={() => {setShow((!show))}}>
								<img style={{width:12,transform:!show?'rotate(0deg)':'rotate(180deg)'}} src={require('../../../fCommon/ViewCreditNote/India/down.png')} alt="down"/>
							</div> 
						</div>
						{(show)?<div style={{marginLeft:'1rem'}}>
							<CustomTagsContract title={"Vendor Custom Tags"} data={(data && data.vendor && data.vendor.customTags)?data.vendor.customTags:{}}/>
							<CustomTagsContract title={"Ship To Custom Tags"} data={(data && data.shipTo && data.shipTo.tags)?data.shipTo.tags:{}}/>
							<CustomTagsContract title={"Billing To Custom Tags"} data={(data && data.billingTo && data.billingTo.tags)?data.billingTo.tags:{}}/>
						</div>:null}
					</div>
                </div>
				<div style={{marginLeft:20}}>
				<Header container={true} style={{marginLeft:20}} id="terms" title="Logs" />
				</div>
				<div className='input-container'>
				  {
                       data.logs&& data.logs.length>0?
					   data.logs.map((item, index)=>{
                                return(
									<div  key={`comments-${index}`}>
										<span style={{color: '#666', marginRight: '5px'}}>{moment(item.date).format(" hh:mm a DD MMM YY")}</span>
										: {item.log}
									   </div>	
								)
                            })
                            : <p>No Logs</p>
                  }
				</div>
			
			{
				addressType ?
					<OfficeModal
						p2p={true}
						close={() => {
							setAddressType(false);
						}}
						onSelect={(i) => {
							if (addressType === 'shipTo') {
								let data = {
									key:'shipTo',
									value:`${i.id}`
								}
								if(status==='GRN' || status==='DRAFT' || status==='ADMINTOUCH') {
									data.force = true
								}
								post(`vendor/po/requests/${id}/updateDetails`, data, (e, r) => {
									if (r) {
										props.init();
										setAddressType(false);

										showToast({
											type: 'success',
											message: "Address update successfuly"
										})
									} else {
										handleError(e);
									}
								})
							} else {
								let data = {
									key:'billTo',
									value:`${i.id}`
								}
								if(status==='GRN' || status==='DRAFT' || status==='ADMINTOUCH') {
									data.force = true
								}
								post(`vendor/po/requests/${id}/updateDetails`, data, (e, r) => {
									if (r) {
										props.init();
										setAddressType(false);

										showToast({
											type: 'success',
											message: "Address update successfuly"
										})
									} else {
										handleError(e);
									}
								})
							}
						}}
					/>
					: null
			}
			{vendorAddress ?
			<VendorAddressSearch
				close={()=>{
					setVendorAddress(false)
				}}
				office={data.details.addressId}
				id={vendorAddress}
				onSelect={(i)=>{
					let data = {
						key:'vendorAddress',
						value:i
					}
					if(status==='GRN' || status==='DRAFT' || status==='ADMINTOUCH') {
						data.force = true;
					}
					post(`vendor/po/requests/${id}/updateDetails`,data,(e,r)=>{
						if(r) {
							showToast({
								type:'success',
								message:"Address updated Successfully"
							})
							setVendorAddress(false);
							props.init()
						} else {
							showToast({
								type:'error',
								message:e.data.message
							})
						}
					})
				}}

				/>:null}
				{
                addLineItem?
                    <Modal buttonName="Add Product" show={addLineItem}
                           title="Search Product"
                           des="Search product to add here"
                           style={
                               {
                                   save: {
                                       width: '100%',
                                       fontSize: 14,
                                       height: 44,
                                       display: 'flex',
                                       justifyContent: 'center',
                                       alignItems: 'center',
                                   }
                               }
                           }
                           onSave={savePoItem}
                           close={() => {
                               setAddLineItem(false)
                           }}>
						  <>
                <ProductSearch
                  product={product}
                  selectCategory={data.category && data.category}
                  onSelect={(item) => {
                    setProduct(item);
                  }}
                />
				{(product && (props.data && props.data.currency === 'INR')) &&
					<SelectGST defaultValue={productGST} placeholder="Select Gst" onSelect={setProductGST}/>
					}
  				<SearchOffice2
					office={shipping}
					title="Delivery Address"
					onSelect={(add) => {
						setShipping(add);
					}}
				/>
				<DatePickerCustom
					ref={DELIVERY_DATE}
					label={"Delivery Date"}
					formate={dateFormate}
				/>
                <FunctionalInput type="number" title="Quantity" ref={QTTY}  />
                <FunctionalInput type="number" title="Base Amount" ref={BASE}  />
                <FunctionalInput type="text" title="Notes" ref={NOTES} />
                 </>
                    </Modal>:undefined
                  }
				{
                short?
                    <Modal buttonName="Create" show={short}
                           title="Confirmation Dialog"
                           des="Do you want to create purchase order from this items"
                           style={
                               {
                                   save: {
                                       width: '100%',
                                       fontSize: 17,
                                       height: 44,
                                       display: 'flex',
                                       justifyContent: 'center',
                                       alignItems: 'center',
                                   }
                               }
                           }
                           onSave={() => {

                              let remarks = REMARKS.current.value;
                              if(!remarks) {
                                  showToast({
                                      type:'error',
                                      message:"Please enter the remarks"
                                  })
                                  return
                              }
                               post(`vendor/po/requests/${id}/short`, {
                                   remarks
                               }, (e, r) => {
                                   if (r) {

									   showToast({
										   type:'success',
										   message:"Short Closure done successfully"
									   })
                                       REMARKS.current.value ='';
									   props.init();
                                       setShort(false);

                                   } else {
                                       handleError(e)
                                   }
                               })
                           }}
                           close={() => {
                               setShort(false)
                           }}>
                       <FunctionalInput type="text" title="Remarks" ref={REMARKS} />
                    </Modal>:undefined
            }
			{
                completePo?
                    <Modal 
						stateLoading={btnLoading}
						buttonName="Complete PO" show={completePo}
                           title="Confirmation Dialog"
                           des="Do you want to complete this Purchase Order"
                           style={
                               {
                                   save: {
                                       width: '100%',
                                       fontSize: 17,
                                       height: 44,
                                       display: 'flex',
                                       justifyContent: 'center',
                                       alignItems: 'center',
                                   }
                               }
                           }
                           onSave={() => {
							setBtnLoading(true)
							post(`vendor/po/requests/${id}/complete`, {}, (e, r) => {
								if (r) {
									setBtnLoading(false)
									init();
								} else {
									setBtnLoading(false)
									handleError(e)
								}
								setCompletePo(false);

							})
                           }}
                           close={() => {
							setBtnLoading(false)
                               setCompletePo(false)
                           }}>
                    </Modal>:undefined
            }
			{
				name?
				<Modal
					close={()=>setName(false)}
					buttonName="update" show={true}
					title="Confirmation Dialog"
					des={name==='admin'?"Change PO owner":name=== 'gin' ? 'Change Gin Owner': "Change GRN owner"}
					style={
						{
							save: {
								width: '100%',
								fontSize: 17,
								height: 44,
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}
						}
					}
					onSave={()=>{


						if(!employee) {
							showToast({
								type:'error',
								message:'Please select the employee'
							})
							return;
						}

					

						if(name==='admin') {
							post(`vendor/po/requests/${id}/po.owner`, {code:employee.value}, (e, r) => {
								if (r) {

									props.init();
									setName(false);
									showToast({
										type: 'success',
										message: "PO owner update successfuly"
									})
									
								} else {
									handleError(e);
								}
							})
						} else if(name === 'gin') {
							get(`vendor/procurement/gin/updateGinOwner/${id}?employeeCode=${employee.value}`, (e, r) => {
								if (r) {
									props.init();
									setName(false);
									showToast({
										type: 'success',
										message: "GIN owner update successfully"
									})
								} else {
									handleError(e);
								}
							})
						} else {
							post(`vendor/po/requests/${id}/grn.owner`, {code:employee.value}, (e, r) => {
								if (r) {

									props.init();
									setName(false);
									showToast({
										type: 'success',
										message: "GRN owner update successfuly"
									})		

					
									
								} else {
									handleError(e);
								}
							})
						}

						
					}}
					>
					<EmployeeSearchable employee={employee} onSelect={employee=>{
						setEmployee(employee)
					}}/>

				</Modal>
				: null
			}
			{removeCostAllocation && <Modal
				close={()=>setRemoveCostAllocation(false)}
				buttonName="Remove"
				show={removeCostAllocation}
				title="Confirmation Dialog"
				des="Do you want to remove the cost allocation?"
				onSave={()=>{
					post(`/vendor/costAllocation/removePoLocation`,{
						poId:Number(id),
					}, (e, r) => {
						if (r) {
							setRemoveCostAllocation(false)
							showToast({
								type: 'success',
								message: "Cost allocation removed successfully"
							})
							if(ALLOCATION.current && ALLOCATION.current.INIT) {
								ALLOCATION.current.INIT();
							}
							props.init();
							setRemoveCostAllocation(false);
						} else {
							handleError(e)
						}
					})
				}}
			/>}
		</div>
	)
}


export default Details
